import APIKit from '../Allapis/Apikit/apikit'

export const getOffersServer = async id => {
  const endpoint = id ? `promotions/getOffers/${id}` : `promotions/getOffers`
  const res = await APIKit.get(endpoint)
  return res.data
}

export const updateOffersServer = async (id, values) => {
  const res = await APIKit.put(`/offers/${id}`, values)
  return res.data
}

export const createAndUpdateOffersServer = async (id, values) => {
  let res
  if (id) {
    res = await APIKit.post(`promotions/offers/${id}`, values)
  } else {
    res = await APIKit.post(`promotions/offers`, values)
  }
  return res.data
}

export const deleteOffersServer = async del_id => {
  const res = await APIKit.put(`/offers/${del_id}`)
  return res.data
}
